import { z } from 'zod'

import { useApiSWR } from '~/api/swr/useApiSWR.ts'

export const onboardingGoalsResponseBody = z.object({
  goals: z.object({
    first_template: z.string().nullable(),
    has_assembly_from_template_editor: z.string().nullable(),
    has_assembly_from_integration: z.string().nullable(),
  }),
})

export function useOnboardingGoals() {
  return useApiSWR('/api/user/goals.json', { out: onboardingGoalsResponseBody })
}
